var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FF4837"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 14.9466L14.9461 7.87549L16.1246 9.054L9.05351 16.1251L7.875 14.9466Z",
    fill: "white",
    fillOpacity: 0.94
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05351 7.87549L16.1246 14.9466L14.9461 16.1251L7.875 9.054L9.05351 7.87549Z",
    fill: "white",
    fillOpacity: 0.94
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.46ba50af6bf2c0df0d00b975ee538732.svg";
export { ForwardRef as ReactComponent };